import {defineMessages} from 'react-intl';

const messages = defineMessages({
	buttonClearLabel: {
		id: 'toolkit.button.clear.label',
		defaultMessage: 'Clear',
	},
	buttonApplyGroupsLabel: {
		id: 'toolkit.button.applyGroups.label',
		defaultMessage: 'Apply groups',
	},
	buttonApplyStorefrontLabel: {
		id: 'toolkit.button.applyStorefront.label',
		defaultMessage: 'Apply storefront',
	},
	customerGroupConfigurationError: {
		id: 'toolkit.customerGroupConfigurationError',
		defaultMessage: 'It seems that the customer group you have chosen is not properly configured.',
	},
	customerGroupsTitle: {
		id: 'toolkit.customerGroupsTitle',
		defaultMessage: 'Customer groups',
	},
	activeGroupsTitle: {
		id: 'toolkit.activeGroupsTitle',
		defaultMessage: 'Active groups ({count})',
	},
	sourceCodePlaceholder: {
		id: 'toolkit.sourceCodePlaceholder',
		defaultMessage: 'Source code',
	},
	storefrontToolkitTitle: {
		id: 'toolkit.storefrontToolkitTitle',
		defaultMessage: 'Storefront toolkit',
	},
});

export default messages;
